type Warns =
  | 'invalidSDKOptions'
  | 'invalidPaymentElementOptions'
  | 'invalidPaymentInstructionsElementOptions'
  | 'invalidDocumentCollectorElementOptions'
  | 'invalidLRSElementOptions'
  | 'invalidPaymentMethodSelectorElementOptions'
  | 'invalidRecipientFieldsElementOptions'
  | 'overridingPaymentElementContainer';

export const warn = (type: Warns, payload: object) => {
  console.warn({
    type,
    warnings: payload
  });
};
